import React, { PureComponent } from 'react'
import {
    ShimmeredDetailsList, SelectionMode, DetailsListLayoutMode, ConstrainMode, buildColumns, Text, IColumn,
} from '@fluentui/react'
import history from 'helpers/history'
import { handleRenderColumn, onColumnClick } from 'helpers/methods/common'
import Status from 'types/status'
// eslint-disable-next-line import/named
import { AppProps } from 'app'
import HomeActuality from 'requests/objects/homeActuality'
import { Link } from 'react-router-dom'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import flattenObj from 'helpers/methods/flattenObj'
import homeActualityColumns from 'types/homeActualities/columns'
import Card from 'components/containers/card'
import styles from 'styles/pages/home-actualities/index.module.scss'
// import { Columns } from 'react-bulma-components'
import { NEW_PATH } from 'types/others'
import { tKey, tObj } from 'helpers/methods/translate'

/** @debug {AppProps} */

/**
 * @augments {PureComponent<AppProps>} extends
 */
export default class IndexHomeActualities extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {IColumn[]} Columns displayed */
            columns: [],
            /** @type {HomeActuality[]} Items found in API */
            items: [],
            /** @type {HomeActuality[]} Initial items found in API */
            iniItems: [],
        }
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        this.init()

        // this.search()
    }

    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     */
    componentDidUpdate(prevProps) {
        const { lang } = this.props

        if (lang !== prevProps.lang)
            this.init()

        // this.init()

        // this.setupBreadcrumb()

        // this.setupCommandBar()

        // this.setState({
        //     columns: this.buildColumns(),
        // })
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.homeActualitiesHandlerGetAll?.cancel()
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb } = this.props

        setBreadcrumb([
            { text: this.tKey('homeActualities'), key: 'homeActuality', isCurrentItem: true },
        ])
    }

    /**
     * Setup commandbar elements
     */
    setupCommandBar() {
        const { setCommand } = this.props

        setCommand(
            [
                {
                    key: 'new',
                    text: this.tKey('new'),
                    iconProps: { iconName: 'Add' },
                    onClick: () => history.push(`/home-actualities/${NEW_PATH}`),
                    disabled: false,
                },
            ],
        )
    }

    /**
     * Init Page
     */
    init() {
        const { setMessageBar, setCommand } = this.props

        setMessageBar({ isDisplayed: false })
        setCommand([])

        this.setupBreadcrumb()
        this.setupCommandBar()

        this.setState({ columns: this.buildColumns() }, () => this.search())
    }

    /**
     * Init <DetailList>
     * @returns {IColumn[]} Columns
     */
    buildColumns() {
        const cols = homeActualityColumns?.reduce((obj, col) => ({ ...obj, [col.fieldName]: col.name }), {})

        const columns = buildColumns(
            [cols],
            true,
            this.onColumnClick.bind(this, {
                colName: 'columns', dataName: ['items'], source: 'state', isFlatten: true,
            }),
        )

        // eslint-disable-next-line no-restricted-syntax
        for (const column of columns) {
            const name = cols[column.key]
            column.name = this.tKey(name) || name
            column.maxWidth = (() => {
                switch (name) {
                    case 'status':
                        return 170
                    case 'title':
                        return 250
                    case 'startDate':
                        return 150
                    case 'endDate':
                        return 150
                    case 'companies':
                        return 300
                    case 'inProgress':
                        return 150
                    case 'createdAt':
                        return 150
                    default:
                        return (column.name?.length ?? 1) * 12
                }
            })()
            column.minWidth = (column.name?.length ?? 1) * 5
            column.onRender = homeActualityColumns.find(x => x.name === name)?.onRender?.bind(this)
                ?? this.handleRenderColumn(homeActualityColumns, name, column)
        }

        return columns
    }

    /**
     * Search elements
     */
    search() {
        this.setState({
            status: Status.PENDING,
        }, async () => {
            const { homeActualitiesHandler } = this.props
            try {
                this.homeActualitiesHandlerGetAll = homeActualitiesHandler.getAll()
                const homeActualities = await this.homeActualitiesHandlerGetAll.fetch()
                this.setState({
                    items: homeActualities.map(x => this.flattenObj(x)),
                    iniItems: homeActualities,
                    status: Status.RESOLVED,
                })
            } catch (error) {
                switch (error?.constructor) {
                    case CancelRequestError:
                    case UnauthorizedError:
                    case InvalidEntityError: break
                    case NotImplementedError:
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                    default:
                        this.setState({
                            items: [],
                            iniItems: [],
                            status: Status.REJECTED,
                        })
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                }
            }
        })
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            columns, status, items, iniItems,
        } = this.state

        return (
            <main className={styles.index}>
                <Card>
                    <ShimmeredDetailsList
                        items={items}
                        columns={columns}
                        selectionMode={SelectionMode.none}
                        onShouldVirtualize={() => true}
                        enableShimmer={status === Status.PENDING}
                        layoutMode={DetailsListLayoutMode.justified}
                        constrainMode={ConstrainMode.unconstrained}
                        onRenderDetailsHeader={(props, defaultRender) => defaultRender({ ...props, styles: { root: { paddingTop: 0 } } })}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        onRenderRow={(props, defaultRender) => (
                            <Link
                                to={{
                                    pathname: `/home-actualities/${props.item?.homeActualityId}`,
                                    state: {
                                        homeActuality: iniItems.find(x => x.homeActualityId === props.item?.homeActualityId),
                                    },
                                }}
                            >
                                {defaultRender(props)}
                            </Link>
                        )}

                    />
                    {!items?.length && [Status.RESOLVED, Status.REJECTED].includes(status)
                        && <Text styles={{ root: { fontStyle: 'italic', marginLeft: '1em' } }}>{this.tKey('noResultFound')}</Text>}
                </Card>
            </main>
        )
    }
}

IndexHomeActualities.prototype.onColumnClick = onColumnClick
IndexHomeActualities.prototype.flattenObj = flattenObj
IndexHomeActualities.prototype.handleRenderColumn = handleRenderColumn
IndexHomeActualities.prototype.tKey = tKey
IndexHomeActualities.prototype.tObj = tObj
